import { OOS_THRESHOLD_REGEX } from 'utils/constants'
import { INVENTORY_FORM_FIELDS } from '../constants/formFields'
import * as yup from 'yup'

const { OOS_THRESHOLD, USE_GLOBAL_THRESHOLD, ERP_QTY } = INVENTORY_FORM_FIELDS

export const updateInventorySchema = yup.object().shape({
  [ERP_QTY.key]: yup
    .number()
    .typeError('ERP Quantity must be a number')
    .required('ERP Quantity is a required field')
    .min(0, 'ERP Quantity cannot be negative'),
  [OOS_THRESHOLD.key]: yup
    .string()
    .required('OOS Threshold is required field')
    .matches(OOS_THRESHOLD_REGEX, 'OOS Threshold must be a positive integer'),
  [USE_GLOBAL_THRESHOLD.key]: yup.boolean(),
})

export type UpdateInventoryType = yup.InferType<typeof updateInventorySchema>
